/*
 * "Complete the set" - behaviour only.
 *
 * The sheet and every variant row are rendered by
 * snippets/complete-the-set.liquid, so there is no variant list to
 * reconstruct and no availability to go looking for.
 *
 * The original detected an add-to-cart by replacing window.fetch AND
 * XMLHttpRequest.prototype.open/send for the whole page, then guessed whether
 * the call belonged to the main product form using a capture-phase click
 * listener, a 3-second time window and a blocklist of bundle/upsell selectors.
 * The theme already announces the add: <product-form> dispatches a bubbling
 * "variant:add" carrying the line items it just added. That event is what this
 * listens to.
 *
 * Ported from the Variant experience exp-EXPE4A45035.
 */
(function () {
  'use strict';

  var CLOSE_ANIMATION_MS = 350;

  function init(root) {
    if (root.dataset.completeSetReady) return;
    root.dataset.completeSetReady = '1';

    var panel = root.querySelector('.complete-set__panel');
    var chosenSlot = root.querySelector('[data-complete-set-chosen]');
    var chosenLabel = root.querySelector('[data-complete-set-chosen-label]');
    var submitButton = root.querySelector('[data-complete-set-submit]');
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-complete-set-row]'));
    if (!panel || !chosenSlot || !submitButton || !rows.length) return;

    var offeredRows = rows.slice();
    var scrollLocked = false;

    // -----------------------------------------------------------------------
    // Opening
    // -----------------------------------------------------------------------
    function rowFor(variantId) {
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].getAttribute('data-variant-id') === String(variantId)) return rows[i];
      }
      return null;
    }

    function open(addedVariantId) {
      var addedRow = rowFor(addedVariantId);
      if (!addedRow) return false;

      offeredRows = rows.filter(function (row) {
        return row !== addedRow;
      });

      // Nothing left worth offering.
      var anyInStock = offeredRows.some(function (row) {
        return !row.hasAttribute('data-sold-out');
      });
      if (!anyInStock) return false;

      // Move the chosen variant up top and lock it.
      addedRow.classList.add('is-chosen', 'is-checked');
      var addedCheckbox = addedRow.querySelector('[data-complete-set-checkbox]');
      if (addedCheckbox) {
        addedCheckbox.checked = true;
        addedCheckbox.disabled = true;
      }
      var inCartBadge = addedRow.querySelector('.complete-set__badge--in-cart');
      if (inCartBadge) inCartBadge.hidden = false;
      chosenSlot.appendChild(addedRow);
      if (chosenLabel) chosenLabel.hidden = false;

      root.hidden = false;
      lockScroll();

      // Two frames so the opening transition always runs.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          root.classList.add('is-visible');
        });
      });

      refreshSubmit();
      return true;
    }

    function close(openDrawerAfter) {
      root.classList.remove('is-visible');

      setTimeout(function () {
        root.hidden = true;
        unlockScroll();
        if (openDrawerAfter) showCartDrawer();
      }, CLOSE_ANIMATION_MS);
    }

    function lockScroll() {
      if (scrollLocked) return;
      scrollLocked = true;
      var scrollbar = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      if (scrollbar > 0) document.body.style.paddingRight = scrollbar + 'px';
    }

    function unlockScroll() {
      if (!scrollLocked) return;
      scrollLocked = false;
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }

    // -----------------------------------------------------------------------
    // Selection
    // -----------------------------------------------------------------------
    function selectedLines() {
      return offeredRows
        .filter(function (row) {
          if (row.hasAttribute('data-sold-out')) return false;
          var checkbox = row.querySelector('[data-complete-set-checkbox]');
          return checkbox && checkbox.checked;
        })
        .map(function (row) {
          var quantityInput = row.querySelector('[data-complete-set-qty-input]');
          return {
            id: parseInt(row.getAttribute('data-variant-id'), 10),
            quantity: quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1
          };
        });
    }

    function refreshSubmit() {
      if (submitButton.classList.contains('is-loading')) return;
      submitButton.disabled = selectedLines().length === 0;
    }

    root.addEventListener('change', function (event) {
      var checkbox = event.target.closest('[data-complete-set-checkbox]');
      if (checkbox) {
        var row = checkbox.closest('[data-complete-set-row]');
        if (row) row.classList.toggle('is-checked', checkbox.checked);
        refreshSubmit();
        return;
      }

      var quantityInput = event.target.closest('[data-complete-set-qty-input]');
      if (quantityInput) setQuantity(quantityInput, parseInt(quantityInput.value, 10) || 1);
    });

    function setQuantity(input, value) {
      var next = Math.max(1, Math.min(99, value));
      input.value = next;

      var minusButton = input.parentNode.querySelector('[data-complete-set-qty="-1"]');
      if (minusButton) minusButton.disabled = next <= 1;
    }

    root.addEventListener('click', function (event) {
      if (event.target === root || event.target.closest('[data-complete-set-dismiss]')) {
        close(true);
        return;
      }

      var stepButton = event.target.closest('[data-complete-set-qty]');
      if (stepButton) {
        var input = stepButton.parentNode.querySelector('[data-complete-set-qty-input]');
        if (input) {
          setQuantity(input, (parseInt(input.value, 10) || 1) + parseInt(stepButton.getAttribute('data-complete-set-qty'), 10));
        }
        return;
      }

      if (event.target.closest('[data-complete-set-submit]')) submit();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || root.hidden) return;
      close(true);
    });

    // -----------------------------------------------------------------------
    // Adding
    // -----------------------------------------------------------------------
    function sectionIds() {
      return ['cart-drawer', 'header']
        .map(function (name) {
          var element = document.querySelector('.shopify-section[id*="' + name + '"]');
          return element ? element.id.replace('shopify-section-', '') : null;
        })
        .filter(Boolean)
        .join(',');
    }

    function submit() {
      var lines = selectedLines();
      if (!lines.length) {
        close(true);
        return;
      }

      submitButton.classList.add('is-loading');
      submitButton.disabled = true;

      var sections = sectionIds();
      var body = { items: lines };
      if (sections) {
        body.sections = sections;
        body.sections_url = window.location.pathname;
      }

      fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (json) {
          if (json && json.sections) renderSections(json.sections);
        })
        .catch(function () {
          /* the sheet closes either way - the drawer will show the truth */
        })
        .then(function () {
          submitButton.classList.remove('is-loading');
          close(true);
        });
    }

    function renderSections(sections) {
      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        if (html == null) return;
        var element = document.getElementById('shopify-section-' + id);
        if (!element) return;
        element.outerHTML = html;
        document.dispatchEvent(
          new CustomEvent('shopify:section:load', { detail: { sectionId: id } })
        );
      });
    }

    // -----------------------------------------------------------------------
    // Cart drawer
    //
    // The theme opens the drawer from its own "cart:change" listener, which we
    // cannot cancel. It is driven by an "open" attribute rather than a native
    // modal, so it is held shut for as long as the sheet is up and released
    // afterwards.
    // -----------------------------------------------------------------------
    var drawerGuard = null;

    function cartDrawer() {
      return document.querySelector('cart-drawer');
    }

    function holdCartDrawerShut() {
      var drawer = cartDrawer();
      if (!drawer || drawerGuard) return;

      drawer.removeAttribute('open');
      drawerGuard = new MutationObserver(function () {
        if (drawer.hasAttribute('open')) drawer.removeAttribute('open');
      });
      drawerGuard.observe(drawer, { attributes: true, attributeFilter: ['open'] });
    }

    function releaseCartDrawer() {
      if (!drawerGuard) return;
      drawerGuard.disconnect();
      drawerGuard = null;
    }

    function showCartDrawer() {
      releaseCartDrawer();
      var drawer = cartDrawer();
      if (!drawer) return;
      requestAnimationFrame(function () {
        drawer.setAttribute('open', '');
      });
    }

    // -----------------------------------------------------------------------
    // The trigger
    // -----------------------------------------------------------------------
    document.addEventListener('variant:add', function (event) {
      // Only the main product form - not a quick-buy drawer, a bundle or an
      // upsell app, all of which add to the cart from elsewhere on the page.
      //
      // getAttribute, not .id: a product form contains <input name="id"> for
      // the variant, and a form's named controls shadow its own properties,
      // so form.id is that input element rather than the form's id string.
      var form = event.target.closest ? event.target.closest('form') : null;
      var formId = (form && form.getAttribute('id')) || '';
      if (formId.indexOf('product-form-main') !== 0) return;
      if (!root.hidden) return;

      var items = (event.detail && event.detail.items) || [];
      if (!items.length) return;

      holdCartDrawerShut();

      // Nothing to offer: step aside and let the theme open the drawer as it
      // normally would.
      if (!open(items[0].id)) releaseCartDrawer();
    });

    function rootUrl() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }
  }

  function boot() {
    var root = document.querySelector('[data-complete-set]');
    if (root) init(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
